import React from 'react';
import { DialogContainer, LoadingSkeleton } from '../../../common/components';
import ContractEditTable from './ContractEditTable';
import ContractIndividualEditDialog from './individual-contract/ContractIndividualEditDialog';
import { useContractEditList } from '../hooks/useContractEditList';

/**
 * Diálogo de edición de contratos
 * Refactorizado para seguir los patrones del proyecto
 */
const ContractEditDialog = ({
  open,
  onClose,
  contractFilters = {},
  isArchiveDialog = false,
  save,
  setSave,
}) => {
  const {
    // Estados de datos
    displayedContracts,
    isLoading,

    // Estados de filtros y paginación
    filterInputs,
    page,
    totalPages,
    totalCount,
    rowsPerPage,

    // Datos de soporte
    groups,

    // Funciones de manejo
    handleFilterChange,
    handlePageChange,
    handleRowsPerPageChange,
    handleEdit,

    // Estados del diálogo individual
    editDialogOpen,
    selectedContract,
    handleCloseEditDialog,
    handleSaveContract,
  } = useContractEditList({
    contractFilters,
    open,
    save,
    setSave,
  });

  if (!open) return null;

  return (
    <>
      <DialogContainer open={open} onClose={onClose} size="fullWidth" minHeight="95vh">
        {isLoading ? (
          <LoadingSkeleton />
        ) : (
          <ContractEditTable
            contracts={displayedContracts}
            filterInputs={filterInputs}
            page={page}
            totalPages={totalPages}
            totalCount={totalCount}
            rowsPerPage={rowsPerPage}
            groups={groups}
            isArchived={isArchiveDialog}
            onFilterChange={handleFilterChange}
            onPageChange={handlePageChange}
            onRowsPerPageChange={handleRowsPerPageChange}
            onEdit={handleEdit}
            onClose={onClose}
          />
        )}
      </DialogContainer>

      <ContractIndividualEditDialog
        open={editDialogOpen}
        onClose={handleCloseEditDialog}
        contract={selectedContract}
        onSave={handleSaveContract}
        isArchived={isArchiveDialog}
        save={save}
        setSave={setSave}
      />
    </>
  );
};

export default ContractEditDialog;
